export class Inventary{
  constructor(
    public ID:number,
    private max_units:number,
    private min_units:number,
    private units:number,
    private Product_ID: number,
    private Warehouse_ID:number,
    private name:string
  )
  {

  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/models/inventary.model.ts